/*
 *   File : basket.js
 *   Author : https://evoqins.com
 *   Description : Basket card component
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

//Custom components
import { TextButton } from '../Buttons';

//Style
import style from "../../Style/Component/card.module.scss";

//Custom components
import { Chip } from '../Others';

const BasketCard = (props) => {


    const navigate = useNavigate();

    // handle navigate to re-balance history
    const _handleRebalanceHistory = () => {
        navigate("rebalance-history");
    };

    const _handleEdit = () => {
        navigate("manage-basket", {
            state: {
                basket_data: props.basketData,
                selected_tab: props.selectedTab,
                duration: props.duration,
                edit: true
            }
        })
    };

    return (

        props.type === 3 ? (
            <div className='e-bg-magnolia border-radius-8'>
                <div className='d-flex align-items-center justify-content-between px-4 pt-4 padding-18px-bottom'>
                    <div className='col-10'>
                        <p className='mb-0 text-start e-text-davys-grey e-primary-font e-font-14 e-font-weight-700 line-height-24px'>
                            Fund name
                        </p>
                    </div>
                    <TextButton name="Edit"
                        className="e-hover"
                        onClick={_handleEdit} />
                </div>
                {/* Funds */}
                <div>
                    <div className='e-border-bottom-1px-pale-lavender-light mx-4'>
                        {/* {props.basketData.map((fund, key) => ( */}
                        <div className={` padding-18px-bottom `}>
                            <div className='row'>
                                <div className='col-10'>
                                    <div className='d-flex align-items-center gap-3'>
                                        <div className='e-bg-white padding-6px-all border-radius-4 e-border-0-5px-bright-gray'>
                                            <img src={props.basketData.fund_image}
                                                draggable={false}
                                                width={38}
                                                className='d-flex'
                                                height={38}
                                                alt='fund' />
                                        </div>
                                        <p className='text-start mb-0 e-text-smoky-black e-alt-font e-font-14 e-font-weight-400 line-height-24px'>
                                            {props.basketData.fund_name}
                                        </p>
                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>

                    <div className='pt-3 px-4 pb-4 '>
                        <div className='d-flex gap-2 align-items-center flex-wrap'>
                            <p className='mb-0 e-text-smoky-black e-alt-font e-font-14 e-font-weight-400 line-height-24px'>
                                Customers invested: <span className='e-font-weight-700'>{props.basketData.customers_invested}</span>
                            </p>
                            <span className='vr e-bg-pale-lavender-light'></span>
                            <p className='mb-0 e-text-smoky-black e-alt-font e-font-14 e-font-weight-400 line-height-24px'>
                                Last updated on: <span className='e-font-weight-700'>{props.basketData.last_updated}</span>
                            </p>
                        </div>
                    </div>
                </div>


            </div>
        ) : (
            <div className='e-bg-magnolia border-radius-8 d-flex flex-column h-100 justify-content-between'>
                <div>

                    <div className='d-flex align-items-center justify-content-between px-4 padding-26px-tb'>
                        <div className='d-flex align-items-center gap-2 '>
                            {props.type === 2 ?
                                <>
                                    <h6 className='text-start mb-0 e-text-smoky-black e-primary-font e-font-16 e-font-weight-600 line-height-20px'>
                                        {props.basketData.basket_name}
                                    </h6>
                                    <Chip label={props.basketData.is_active}
                                        className={`${props.basketData.is_active === "Active" ? "e-bg-green-crayola" : "e-bg-dark-silver"}  py-0`} />
                                </>
                                :
                                <h6 className='mb-0 e-text-smoky-black e-primary-font e-font-16 e-font-weight-600 line-height-20px'>
                                    {props.basketData.basket_investment_name}
                                </h6>
                            }
                        </div>

                        <TextButton name="Edit"
                            className="padding-32px-right e-hover"
                            onClick={_handleEdit} />
                    </div>
                    {/* Funds */}
                    <div className='px-4 pb-2'>
                        <div className='row'>
                            <div className='col-9'>
                                <p className='text-start mb-0 e-text-davys-grey e-primary-font e-font-14 e-font-weight-700 line-height-24px'>
                                    Funds
                                </p>
                            </div>
                            <div className='col-3'>
                                <p className='mb-0 text-end e-text-davys-grey e-primary-font e-font-14 e-font-weight-700 line-height-24px'>
                                    Allocation
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className='pb-4'>
                        {props.basketData.funds.map((fund, key) => (
                            <div key={key} className={`${style.e_funds_wrapper} py-3 px-4 `}>
                                <div className='row'>
                                    <div className='col-10'>
                                        <div className='d-flex align-items-start gap-2'>
                                            <div className={`${style.e_fund_img_wrapper} e-bg-white padding-2px-all border-radius-4 mt-1`}>
                                                <img src={fund.fund_image}
                                                    draggable={false}
                                                    width={20}
                                                    className='d-flex object-fit-contain'
                                                    height={20}
                                                    alt='fund' />
                                            </div>
                                            <p className='text-start mb-0 e-text-smoky-black e-alt-font e-font-14 e-font-weight-400 line-height-24px'>
                                                {fund.fund_name}
                                            </p>
                                        </div>

                                    </div>
                                    <div className='col-2'>
                                        <p className='text-start mb-0 e-text-smoky-black e-alt-font e-font-14 e-font-weight-400 line-height-24px'>
                                            {fund.allocation}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                <div className='e-border-top-1px-pale-lavender-light'>
                    <div className='py-3 px-4 e-border-bottom-1px-pale-lavender-ligh'>
                        <div className='d-flex gap-2 align-items-center flex-wrap'>
                            <p className='mb-0 e-text-smoky-black e-alt-font e-font-14 e-font-weight-400 line-height-24px'>
                                Customers invested: <span className='e-font-weight-700'>{props.basketData.customers_invested}</span>
                            </p>
                            <span className='vr e-bg-pale-lavender-light'></span>
                            <p className='mb-0 e-text-smoky-black e-alt-font e-font-14 e-font-weight-400 line-height-24px'>
                                Min SIP: <span className='e-font-weight-700'>{props.basketData.min_sip}</span>
                            </p>
                            <span className='vr e-bg-pale-lavender-light'></span>
                            <p className='mb-0 e-text-smoky-black e-alt-font e-font-14 e-font-weight-400 line-height-24px'>
                                Min lumpsum: <span className='e-font-weight-700'>{props.basketData.min_lumpsum}</span>
                            </p>
                            <span className='vr e-bg-pale-lavender-light'></span>
                            <p className='mb-0 e-text-smoky-black e-alt-font e-font-14 e-font-weight-400 line-height-24px'>
                                Last updated on: <span className='e-font-weight-700'>{props.basketData.last_updated}</span>
                            </p>
                        </div>
                    </div>
                    {/* Buttons */}
                    {/* <div className='d-flex align-items-center justify-content-between gap-3 flex-wrap pt-3 pb-4 px-4'>
                        <TextButton name="View Rebalance History"
                            className="e-hover"
                            onClick={_handleRebalanceHistory} />
                        <TextButton name="Trigger Rebalance"
                            className="e-hover"
                            onClick={props.handleRebalance} />
                    </div> */}
                </div>
            </div >
        ))
}

export default BasketCard;
